<div class="bg-white mt-2">
  <div>
    <div class="left-side" style="padding: 0% 1.5%;">
      <h2 class="m-0" translate>Upload E-Content</h2>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form">
      <div class="row">
        <div
          *ngFor="let question of questions"
          class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
        >
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>
      <!-- File Upload Field -->
      <div style="flex-direction: row;display: flex;">
      <div style="width: 25vw;"> 
        <label translate>PDF,JPG,JPEG,PNG,MP4 file types are allowed.</label>
      <input
          type="file"
          (change)="onFileSelected($event)"
          accept="image/*,application/pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,video/mp4"
          class="custom-file-input"
          placeholder="Attach File"
        />
      </div>
      <!-- <div class="mb-3">
        <div *ngIf="filePreview && isImage" class="mt-2">
          <img
            [src]="filePreview"
            alt="Preview"
            style="max-width: 180px; max-height: 120px; border-radius: 4px"
          />
        </div>
      </div> -->
      </div>
    <div>
      <button
        mat-stroked-button
        color="primary"
        class="buttons"
        type="submit"
        id="real-file"
        [disabled]="!form.valid"
        translate
      >
        Save as Draft
      </button>
      <button
        mat-raised-button
        color="primary"
        class="buttons"
        type="submit"
        id="real-file"
        [disabled]="!form.valid"
        translate
      >
        Upload & Publish
      </button>
    </div>
      <!-- <button mat-button type="button" (click)="onCancel()">Cancel</button> -->
    </form>
    
  </div>
</div>
